import styles from "./rawTextPreview.module.css";

import { Text } from "../text/text";

export const RawTextPreview = ({ text }) => {
    return (
        <div className={styles.preview_container}>
            <Text as="div" variant="body" className={styles.preview} >
                {text}
            </Text>
        </div>
    );
}